export default {
  index() {
    return axios.get(import.meta.env.VITE_SITE_URL + '/persons/bank_accounts');
  },
  accountsBy(person) {
    if (person) {
      return axios.get(import.meta.env.VITE_SITE_URL + '/persons/bank_accounts/bankaccountbyperson/' + person);
    }
    return axios.get(import.meta.env.VITE_SITE_URL + '/persons/bank_accounts/bankaccountbyowner/' + JSON.parse(localStorage.getItem('person')).id);
  },
  accountsByOriginal(originalId) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/persons/bank_accounts/bypersonoriginal/' + originalId);
  },
  store(account) {
    return axios.post(import.meta.env.VITE_SITE_URL + '/persons/bank_accounts', { bankaccount: account });
  },
  show(id) {
    return axios.get(import.meta.env.VITE_SITE_URL + '/persons/bank_accounts/' + id);
  },
  update(account) {
    return axios.put(import.meta.env.VITE_SITE_URL + '/persons/bank_accounts/' + account.id, { bankaccount: account });
  },
  destroy(id) {
    return axios.delete(import.meta.env.VITE_SITE_URL + '/persons/bank_accounts/' + id);
  },
};
